import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

class CanonicalUriService {
    constructor() {
        this._providers = ( new Map());
    }
    registerCanonicalUriProvider(provider) {
        this._providers.set(provider.scheme, provider);
        return {
            dispose: () => this._providers.delete(provider.scheme)
        };
    }
    async provideCanonicalUri(uri, targetScheme, token) {
        const provider = this._providers.get(uri.scheme);
        if (provider) {
            return provider.provideCanonicalUri(uri, targetScheme, token);
        }
        return undefined;
    }
}

export { CanonicalUriService };
